import React from "react";
import Today from "./Today";

export default function ThisMonth() {
  return (
    <>
      <div>
        <Today />
      </div>
    </>
  );
}
